'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dSite$002dId$0024 from "./presto.types$-Site-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$57() {
  this.aGG = null;
  this.aGE = null;
  this.aGF = false;
  this.aGC = null;
  this.aGD = false;
  this.aGH = false;
  this.aGI = false;
  this.aGG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$57 as $c_Lpresto_CredentialsView$$anon$57 };
$p = $c_Lpresto_CredentialsView$$anon$57.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$57;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$57() {
}
export { $h_Lpresto_CredentialsView$$anon$57 as $h_Lpresto_CredentialsView$$anon$57 };
$h_Lpresto_CredentialsView$$anon$57.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aGG;
});
$p.t = (function() {
  if ((!this.aGF)) {
    this.aGE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("site", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aGF = true;
  }
  return this.aGE;
});
$p.ae = (function() {
  if ((!this.aGD)) {
    this.aGC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSite$002dId$0024.$m_Lpresto_types$SiteId$().sF(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().jV(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aGD = true;
  }
  return this.aGC;
});
$p.w = (function() {
  if ((!this.aGI)) {
    this.aGH = false;
    this.aGI = true;
  }
  return this.aGH;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$57 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$57, "presto.CredentialsView$$anon$57", ({
  FZ: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$57 as $d_Lpresto_CredentialsView$$anon$57 };
//# sourceMappingURL=presto.-Credentials-View$$anon$57.js.map
